import api from './api';

export const FacilitiesAPI = {
  getAll: (params = {}) => api.get('/api/v1/specialized_facilities', { params }),
  getOne: (id) => api.get(`/api/v1/specialized_facilities/${id}`),
  create: (data) => api.post('/api/v1/specialized_facilities', data),
  update: (id, data) => api.put(`/api/v1/specialized_facilities/${id}`, data),
  delete: (id) => api.delete(`/api/v1/specialized_facilities/${id}`),
  search: (query) => api.get('/api/v1/specialized_facilities/search', { params: { query } }),
  getByService: (service) => api.get('/api/v1/specialized_facilities/service', { params: { service } }),
};
